import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RoomEventItem, RoomEventsData } from "../../../Types/RoomEvent"

const initialState: RoomEventsData = {
    items: [], selectedItem: {} as RoomEventItem,
    stats: { total_items: 0 },
    filter: { query: '', tags: [], documents: true, images: true },
    isLoading: false
}


const RoomEventsSlice = createSlice({
    name: "RoomEvents",
    initialState: initialState,
    reducers: {
        setRoomEventsData(state, action: PayloadAction<RoomEventsData>) {
            state.items = action.payload.items
            state.selectedItem = action.payload.selectedItem
            state.stats = action.payload.stats
            state.isLoading = action.payload.isLoading
            state.filter = action.payload.filter
        },
    },
})
export const { setRoomEventsData } = RoomEventsSlice.actions
export default RoomEventsSlice.reducer
